module.exports = __webpack_public_path__ + "img/mfm.3387f935.svg";